import { useState } from 'react'
import { useIntl } from '@/intl'

export const useTexts = () => {
  const { translate } = useIntl()

  const [api] = useState(() => ({
    changePassword: translate({ id: 'form.drivers.view.changePasswordModal.controls.send' }),
    cancel: translate({ id: 'form.drivers.view.changePasswordModal.controls.cancel' }),

    changePasswordSuccess: translate({
      id: 'form.drivers.view.changePasswordModal.toast.success',
    }),
    changePasswordGenericError: translate({
      id: 'form.drivers.view.changePasswordModal.toast.genericError',
    }),
    changePasswordWrongOldPasswordError: translate({
      id: 'form.drivers.view.changePasswordModal.toast.wrongOldPasswordError',
    }),
  }))

  return api
}
